var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatePersonal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_714_37679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2632 47.7838V11.2973C89.2632 9.36193 88.5146 7.50584 87.1821 6.13733C85.8496 4.76882 84.0423 4 82.1579 4H11.1053C9.22083 4 7.41358 4.76882 6.08108 6.13733C4.74859 7.50584 4 9.36193 4 11.2973V84.2703C4 86.2056 4.74859 88.0617 6.08108 89.4302C7.41358 90.7987 9.22083 91.5676 11.1053 91.5676H46.6316M82.2763 69.6757V94M94 81.7162H70.3158",
    stroke: "url(#paint0_linear_714_37679)",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 46C53.6274 46 59 40.6274 59 34C59 27.3726 53.6274 22 47 22C40.3726 22 35 27.3726 35 34C35 40.6274 40.3726 46 47 46Z",
    stroke: "url(#paint1_linear_714_37679)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 67C68 55.955 58.3728 47 46.5 47C34.6272 47 25 55.955 25 67",
    stroke: "url(#paint2_linear_714_37679)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_714_37679",
    x1: 49,
    y1: -24.5,
    x2: 49,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B90D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242963"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_714_37679",
    x1: 47,
    y1: 22,
    x2: 47,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242B65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_714_37679",
    x1: 46.5,
    y1: 47,
    x2: 46.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242B65"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_714_37679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePersonal);
export default __webpack_public_path__ + "static/media/create-personal.df7b2efc3b26568c63d0cafa5f0a4ac3.svg";
export { ForwardRef as ReactComponent };